<style lang="less">
@import "../less/common.less";
@import "./passflowAnalysis.less";
</style>
<template>
  <div class="passflowAnalysis">
    <el-form class="search-txt"
             :label-position="labelPosition"
             label-width="80px"
             :model="formLabelAlign">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="部门:">
            <el-select v-model="valueDept"
                       filterable
                       size="medium"
                       placeholder="请选择">
              <el-option v-for="item in optionsDept"
                         :key="item.deptId"
                         :label="item.deptName"
                         :value="item.deptId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="日期:"
                        class="common-date-picker">
            <el-date-picker v-model="startTime"
                            type="date"
                            placeholder="开始日期"
                            :picker-options="pickerOptionsStart"
                            :clearable="false"
                            size="medium"
                            @change="changeStart"></el-date-picker>
            <div class="picker-ico">至</div>
            <el-date-picker v-model="endTime"
                            type="date"
                            placeholder="结束日期"
                            :picker-options="pickerOptionsEnd"
                            @change="changeEnd"
                            size="medium"
                            :clearable="false"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button type="primary"
                     size="small"
                     @click="handleSearch">搜索</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="search-conter"
            :gutter="20">
      <el-col :span="14">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header"
                   class="clearfix">
                <div class="color-lump"></div>
                <div class="chart-title">
                  <span>转化率</span>
                  <!-- （不支持按照设备和区域过滤） -->
                  <!-- <span>总数：0</span> -->
                  <!-- <el-checkbox v-model="checked">包含PC4数据</el-checkbox> -->
                </div>
                <div class="btn-area">
                  <!-- <el-button style="float: right; padding: 3px 0" type="text">精确到门店</el-button> -->
                  <!-- <el-checkbox v-model="checked">包含PC4数据</el-checkbox> -->
                  <!-- <el-button type="info" size="mini">精确到门店</el-button> -->
                </div>
              </div>
              <!-- <div class>1111</div> -->
              <div ref="dom1"
                   id="myChart1"
                   class="charts chart-bar"
                   style="height: 100%;"></div>
              <!-- <div class="bottom-area">
                <div class="content">
                  <div class="items">
                    <div>
                      <span>0</span>%
                    </div>
                    <span>顾客进店率</span>
                  </div>
                  <div class="items">
                    <div>
                      <span>0</span>%
                    </div>
                    <span>成交率</span>
                  </div>
                </div>
              </div>-->
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header"
                   class="clearfix">
                <div class="color-lump"></div>
                <div class="chart-title">
                  <span>到店次数分布</span>
                </div>
              </div>
              <div class="count-style">
                <div class="yAxis"
                     v-if="showYName">次数</div>
                <div id="myChart2"
                     class="charts chart-bar"
                     style="height: calc(100% - 20px);"></div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header"
                   class="clearfix">
                <div class="color-lump"></div>
                <div class="chart-title">
                  <span>男女比例</span>
                </div>
              </div>
              <div id="myChart4"
                   class="charts chart-bar"
                   style="height: 100%;"></div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header"
                   class="clearfix">
                <div class="color-lump"></div>
                <div class="chart-title">
                  <span>年龄段分布</span>
                </div>
              </div>
              <div class="progress-detail">
                <!-- 0: {ageGroupName: "21岁-30岁", groupCount: 6}
1: {ageGroupName: "31岁-40岁", groupCount: 3}
                2: {ageGroupName: "41岁-50岁", groupCount: 1}-->
                <template v-if="ageDistributDetail && ageDistributDetail.length>0">
                  <div v-for="(item,index) in ageDistributDetail"
                       :key="index">
                    <div class="start-txt">{{item.percent}}%</div>
                    <el-progress :percentage="(item.percent/max)*100"
                                 :stroke-width="20"
                                 :show-text="false"></el-progress>
                    <div class="end-txt">{{item.groupCount}}人&nbsp;({{item.ageGroupName}})</div>
                  </div>

                  <!-- <template v-if="ageDistributDetail.length>0&&ageDistributDetail.length<item2.len">
                    <div
                      v-for="(item,index) in (item2.len-ageDistributDetail.length)"
                      :key="index"
                    >&nbsp;</div>
                  </template>-->
                </template>
                <!-- <template v-if="!item2.items || item2.items.length==0">暂无数据</template> -->
              </div>
              <!-- <div class="progress-detail">
                <mt-progress
                  v-for="(item,index) in ageDistributDetail"
                  :value="(item.percent/ageDistributDetail[0].percent)*100"
                  :key="index"
                  :bar-height="5"
                >
                  <div slot="start" class="start-txt">{{item.percent}}%</div>
                  <div slot="end" class="end-txt">{{item.groupCount}}({{item.ageGroupName}})</div>
                </mt-progress>
              </div>-->
              <div id="myChart5"
                   class="charts chart-bar"
                   style="height: 100%;"></div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="10"
              class="conter">
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <div class="color-lump"></div>
            <div class="chart-title">
              <span>时段到店销售表</span>
            </div>
          </div>
          <!-- {{tableData}} -->
          <el-table class="table-common table-border"
                    border
                    show-summary
                    :data="tableData"
                    :row-class-name="tableRowClassName"
                    style="width: 100%">
            <el-table-column prop="houre"
                             label="时段"
                             width="80"
                             fixed
                             align="center">
              <template slot-scope="scope">{{ scope.row.houre }}点</template>
            </el-table-column>
            <el-table-column :prop="item.id"
                             :label="item.label"
                             header-align="center"
                             align="right"
                             v-for="(item,index) in columnAge"
                             :key="index">
              <el-table-column :prop="item2.id"
                               :label="item2.label"
                               header-align="center"
                               align="right"
                               width="50"
                               v-for="(item2,index2) in item.column"
                               :key="index2">
                <template slot-scope="scope">
                  <span v-if="scope.row[item2.id]&&scope.row[item2.id]<=5"
                        style="color:#fe803b;    font-weight: 600 !important">{{ scope.row[item2.id] }}</span>
                  <span v-else-if="scope.row[item2.id]&&scope.row[item2.id]>5"
                        style="color:#75bded;    font-weight: 600 !important">{{ scope.row[item2.id] }}</span>
                  <template v-else>{{ scope.row[item2.id] }}</template>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="total"
                             label="合计"
                             header-align="center"
                             align="right"></el-table-column>
            <el-table-column prop="orderPerMoney"
                             label="客单价"
                             header-align="center"
                             align="right"></el-table-column>
            <el-table-column prop="orderCount"
                             label="客单量"
                             header-align="center"
                             align="right"></el-table-column>
            <el-table-column prop="orderTotalMoney"
                             label="客单总额"
                             header-align="center"
                             align="right"></el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import common from "@/libs/common";
import echarts from "echarts";
import faceApi from "@/api/api-face";
import { Message } from "element-ui";
export default {
  data () {
    return {
      // 部门
      valueDept: "",
      optionsDept: [
        { Id: "0", name: "融智大厦店" },
        { Id: "1", name: "墨文路店" }
      ],
      //时间
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      startTime: new Date(),
      endTime: new Date(),
      labelPosition: "right",
      formLabelAlign: {
        name: "",
        region: "",
        type: ""
      },
      showYName: false,
      checked: false,
      customerType: 0,
      columnAge: [],
      tableData: [],
      ageDistributDetail: [],
      max: 0
    };
  },
  methods: {
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
      } else {
        return "success-row";
      }
      return "";
    },
    init () {
      this.changeStart();
      this.changeEnd();
      this.getDeptList();
    },
    changeStart () {
      this.pickerOptionsStart = Object.assign({}, this.pickerOptionsStart, {
        disabledDate: time => {
          return time.getTime() > this.endTime;
        }
      });
    },
    changeEnd () {
      this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
        disabledDate: time => {
          return time.getTime() < this.startTime;
        }
      });
    },
    // 转化率
    getPercentConvImage (data) {
      let that = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = that.$echarts.init(document.getElementById("myChart1"));

      // 绘制图表
      myChart.setOption({
        color: ["#fe803b", "#45d266", "#75bded"],
        series: [
          {
            name: "转化率",
            type: "funnel",
            left: 0,
            top: 10,
            //x2: 80,
            bottom: 20,
            width: "100%",
            // height: {totalHeight} - y - y2,
            min: 0,
            max: 100,
            minSize: "0%",
            maxSize: "100%",
            sort: "descending",
            gap: 2,
            label: {
              show: true,
              position: "inside",
              // formatter: "{b}\n\n{c}"
              formatter: function (params) {
                return params.data.name + "\n\n" + params.data.label;
              }
            },

            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: "solid"
              }
            },
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 1
            },
            emphasis: {
              label: {
                fontSize: 16,
                formatter: function (params) {
                  return params.data.name + "\n\n" + params.data.label;
                }
              }
            },
            data: [
              // { value: data.orderCount, name: "订单" },
              // { value: data.outCount, name: "店外顾客" },
              // { value: data.inCount, name: "店内顾客" }

              { value: 90, name: "店外顾客", label: data.outCount },
              { value: 60, name: "店内顾客", label: data.inCount },
              { value: 30, name: "订单", label: data.orderCount }
            ]
          }
        ]
      });
    },
    // 到店次数
    getFormattedcountData (countData) {
      let xAxisData = [],
        yAxisData = [1, 2, 3, 4, "≥5"];
      countData.map(item => {
        if (item.arrivalNum >= 5) {
          xAxisData[4] = item.arrivalNumCount;
        } else if (item.arrivalNum > 0 && item.arrivalNum < 5) {
          xAxisData[item.arrivalNum - 1] = item.arrivalNumCount;
        }
      });
      this.getCountImage(xAxisData, yAxisData);
    },
    // 到店次数
    getCountImage (xAxisData, yAxisData) {
      let that = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = that.$echarts.init(document.getElementById("myChart2"));
      that.showYName = true;

      // 绘制图表
      myChart.setOption({
        grid: {
          left: "4%",
          width: "86%",
          top: 0,
          bottom: 0,
          containLabel: true
        },

        xAxis: {
          name: "人数",
          type: "value",
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          name: "次数",
          show: true,
          type: "category",
          data: yAxisData
        },
        // color: ["#fe803b", "#45d266", "#75bded"],
        color: ["#75bded", "#fe803b", "#45d266"],
        series: [
          {
            type: "bar",
            barWidth: 30,
            label: {
              show: true,
              position: "inside",
              color: "#fff"
            },
            itemStyle: {
              color: "#75bded"
            },
            data: xAxisData
          }
        ]
      });
    },
    // 男女比例
    getFormattedgenderRatioData (genderRatioData) {
      let arr = [];
      genderRatioData.map(item => {
        let data = {
          name: item.gendername,
          value: item.genderCount == 0 ? null : item.genderCount
        };
        arr.push(data);
      });
      this.getGenderRatioImage(arr);
    },
    getGenderRatioImage (arr) {
      let that = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = that.$echarts.init(document.getElementById("myChart4"));
      // 绘制图表
      myChart.setOption({
        width: "100%",
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          top: "center",
          right: "10%",
          data: ["男", "女"],
          formatter: function (name) {
            let clientlabels = ["男", "女"];
            let count = 0;
            arr.forEach(item => {
              if (item.name == name) {
                count = item.value ? item.value : 0;
              }
            });
            return name + "：" + count + "人";
          }
        },
        color: ["#75bded", "#fbaa30"],
        series: [
          {
            name: "男女比例",
            type: "pie",
            left: "-10%",
            top: "5%",
            radius: "60%",
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "inside",
              formatter: "{d}%"
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: arr
          }
        ]
      });
    },
    // 年龄段分布
    getAgeDistributionImage (ageGroupList) {
      let that = this;
      let legendData = [];
      let arr = [];
      arr = ageGroupList.map(item => {
        let temp = {
          name: item.ageGroupName,
          value: item.groupCount
        };
        legendData.push(item.ageGroupName);
        return temp;
      });
      // 基于准备好的dom，初始化echarts实例
      let myChart = that.$echarts.init(document.getElementById("myChart5"));
      // console.log("getAgeDistributionImage", arr);
      // 绘制图表
      myChart.setOption({
        width: "100%",
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          top: "center",
          right: "10%",
          data: legendData,
          formatter: function (name) {
            let index = 0;
            let clientlabels = legendData;
            let count = 0;
            arr.forEach(item => {
              if (item.name == name) {
                count = item.value ? item.value : 0;
              }
            });
            return name + "：" + count + "人";
          }
        },
        // color: ["#fe803b", "#45d266", "#75bded"],
        // color: ["#6962ee", "#fbaa30", "#45d266", "#75bded", "#fe803b"],
        color: [
          "#ff803b",
          "#45d367",
          "#75bded",
          "#faaa2f",
          "#01a6ff",
          "#ffd54f",
          "#68f0db"
          // "#fbaa30",
          // "#97e4c0",

          // "#fe803b",
          // "#329afd",
          // "#45d266",
          // "#75bded",
          // "#6962ee"
          // "#98d463",
          // "#7e4cfb",
          // "#fd9826",
          // "#a5c1d7"
        ],
        series: [
          {
            name: "年龄段分布",
            type: "pie",
            left: "-18%",
            top: "5%",
            radius: ["35%", "60%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "outside",
              formatter: "{d}%"
            },
            data: arr
          }
        ]
      });
    },
    // 获取门店列表
    getDeptList () {
      let that = this;
      faceApi.getDeptList().then(
        res => {
          that.optionsDept = res;
          if (res != null && res.length > 0) {
            that.valueDept = res[0].deptId;
            that.handleSearch();
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    // 获取人脸客流数据
    handleSearch () {
      let that = this;
      if (
        that.valueDept == "" ||
        that.valueDept == null ||
        typeof that.valueDept == "undefined"
      ) {
        Message({
          message: "请选择部门！",
          type: "error"
        });
        return;
      }
      console.log(that.valueDept);
      let data = {
        DeptId: that.valueDept,
        BeginDate: common.getTime(that.startTime) + " 00:00:00",
        EndDate: common.getTime(that.endTime) + " 23:59:59"
      };
      faceApi.getFaceData(data).then(
        res => {
          console.log(res);

          // 年龄段分布
          if (res.ageGroupList != null && res.ageGroupList.length > 0) {
            let total = 0;

            res.ageGroupList.map(item => {
              total += item.groupCount;
            });
            let per = 10000;
            let ageDistributDetail = res.ageGroupList.filter((item, index) => {
              if (item.groupCount > 0) {
                let percent = common.toDecimal2(
                  (item.groupCount / total) * 100 + ""
                );
                per = per - percent * 100;
                item["percent"] = percent;
              }

              item["max"] = max;
              return item;
            });
            if (
              per > 0 &&
              ageDistributDetail &&
              ageDistributDetail.length > 0
            ) {
              for (let i = 0; i < per; i += ageDistributDetail.length) {
                ageDistributDetail = ageDistributDetail.map((item, index) => {
                  if (i + index < per) {
                    item["percent"] =
                      (parseFloat(item.percent) * 100 + 1) / 100;
                    item.percent = common.toDecimal2(item.percent + "");
                  }
                  return item;
                });
              }
            }
            let max = 0;
            ageDistributDetail.map(item => {
              max =
                parseFloat(item.percent) > max ? parseFloat(item.percent) : max;
            });
            this.max = max;
            this.ageDistributDetail = ageDistributDetail;
          }
          // 到店次数
          if (
            res.arrivalShopCountList != null &&
            res.arrivalShopCountList.length > 0
          ) {
            that.getFormattedcountData(res.arrivalShopCountList);
          }
          // 男女比例
          if (res.faceGenderList != null && res.faceGenderList.length > 0) {
            that.getFormattedgenderRatioData(res.faceGenderList);
          }
          // 转换率
          that.getPercentConvImage(res.faceCVR);
          // 时段到店销售表
          that.columnAge = [];
          that.tableData = res.faceSalesTable.map((item, index) => {
            let total = 0;
            item.faceItemList.map(faceitem => {
              if (index == 0) {
                that.columnAge.push({
                  id: faceitem.ageGroupName,
                  label: faceitem.ageGroupName,
                  column: [
                    {
                      id: faceitem.ageGroupName + "male",
                      label: "男"
                    },
                    {
                      id: faceitem.ageGroupName + "feMale",
                      label: "女"
                    }
                  ]
                });
              }

              item[faceitem.ageGroupName + "male"] =
                faceitem.maleCOUNT == 0 ? null : faceitem.maleCOUNT;
              item[faceitem.ageGroupName + "feMale"] =
                faceitem.feMaleCOUNT == 0 ? null : faceitem.feMaleCOUNT;
              total += faceitem.maleCOUNT;
              total += faceitem.feMaleCOUNT;
            });
            item["total"] = total == 0 ? null : total;
            item.orderPerMoney =
              item.orderPerMoney == 0
                ? null
                : common.toDecimal2(item.orderPerMoney);
            item.orderCount =
              item.orderCount == 0 ? null : common.toDecimal2(item.orderCount);
            item.orderTotalMoney =
              item.orderTotalMoney == 0
                ? null
                : common.toDecimal2(item.orderTotalMoney);
            return item;
          });
        },
        err => {
          console.log(err);
        }
      );
    }
  },
  mounted () {
    this.init();
  }
};
</script>
<style lang="less">
.el-table {
  .success-row {
    background: #f7f7f7;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/main/passflowAnalysis.vue